import { render, staticRenderFns } from "./ModalCompanyCurrency.vue?vue&type=template&id=0cc67227"
import script from "./ModalCompanyCurrency.vue?vue&type=script&lang=js"
export * from "./ModalCompanyCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports